import { useEffect, useState } from "react";

export type User = {
    id: number,
    username: string,
    first_name: string,
    last_name: string,
    email: string
}

export const useUser = () => {
    const [ user, setUser ] = useState<User | null> (null)
    useEffect (() => {
        getUser()
    }, [])

    const getUser = () => {
        let stringUser: string | null = localStorage.getItem('user')
        let jsonUser = JSON.parse(stringUser as string)
        setUser(jsonUser)
    }


    return user
}